import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
          <div className="lg:max-w-sm">
            <Link to="/" className="inline-flex items-center gap-2 text-xl font-heading text-foreground-900 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-heart-3-fill text-primary-500 text-2xl"></i>
              </div>
              <span>萌白酱</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              知名虚拟UP主与cosplay创作者，用视频和写真传递快乐与美好。感谢每一位粉丝的支持与陪伴！
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 flex-1">
            <div>
              <h4 className="text-sm font-heading text-foreground-900 mb-4">内容分类</h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-heading text-foreground-900 mb-4">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                    关于萌白酱
                  </Link>
                </li>
                <li>
                  <Link to="/category/videos" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                    最新视频
                  </Link>
                </li>
                <li>
                  <Link to="/category/merch" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                    周边产品
                  </Link>
                </li>
                <li>
                  <Link to="/category/community" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                    粉丝社区
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-heading text-foreground-900 mb-4">关注我们</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                    B站：萌白酱Official
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                    微博：@萌白酱
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                    抖音：萌白酱
                  </a>
                </li>
                <li>
                  <a href="mailto:mengbaijiang@example.com" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
                    商务合作
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 萌白酱Official. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200 cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200 cursor-pointer">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}